import React from "react";

export const LazyFundsMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./FundsMultiSelectAutoUpdate"
        )
);
